import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPenjualanAktivaTetapService = new CrudCustom('/transaksi-penjualan-aktiva-tetaps');
export default TransaksiPenjualanAktivaTetapService;
